import React from "react";
import "./styles/variables.css";
import "./styles/global.css";
import Header from "./components/Header";
import InputForm from "./components/InputForm";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <section className="intro">
          <h1>Steuervorteil‑Rechner Neubauimmobilien</h1>
          <p>Ermittle Gewinn, Steuerersparnis & monatliche Belastung.</p>
        </section>
        <InputForm />
      </main>
    </div>
  );
}

export default App;
